export default defineNuxtRouteMiddleware((to, from) => {
  // Skip for initial load or same route
  if (!from || to.path === from.path) return;
  
  /*
  if (process.client) {
    window.scrollTo(0, 0);
  }
  */
}); 